module.exports = __webpack_public_path__ + "static/media/bold.afaf6303.ttf";